import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a832b7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-9 pl-0" }, null, -1))
const _hoisted_4 = { class: "col-3 pr-0" }
const _hoisted_5 = { class: "align-text-left text-color-white" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "eu-logo" }, null, -1))
const _hoisted_7 = { class: "footer d-print-none" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row py-9" }
const _hoisted_10 = { class: "col pl-0" }
const _hoisted_11 = { class: "align-text-left text-color-white" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "align-text-left text-color-white" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "align-text-left text-color-white" }
const _hoisted_16 = {
  key: 0,
  class: "align-text-left text-color-white"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Version: ", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { id: "version-span" }
const _hoisted_20 = { class: "col pr-0" }
const _hoisted_21 = { style: {"font-weight":"bold","color":"white"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "eu-logo" }, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "row py-6 border-top"
}
const _hoisted_24 = { class: "language-switcher" }
const _hoisted_25 = { class: "container" }
const _hoisted_26 = { "aria-label": "Vælg sprog fra listen " }
const _hoisted_27 = ["aria-label"]
const _hoisted_28 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" }, null, -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = ["aria-label"]
const _hoisted_33 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" }, null, -1))
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = ["aria-label"]
const _hoisted_39 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" }, null, -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isTestFramework)
      ? (_openBlock(), _createElementBlock("footer", {
          key: 0,
          class: _normalizeClass(["footer d-print-none ghost-footer", {'slide-down': !_ctx.showGhostFooter}]),
          id: "ghost-footer"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("section", null, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_SimpleText, { "text-key": "footer.supportedby" })
                  ]),
                  _hoisted_6
                ])
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("footer", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("section", null, [
              _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
                [_directive_dompurify_html, _ctx.documentToHtmlString(this.authority)]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("section", null, [
              _withDirectives(_createElementVNode("div", _hoisted_13, null, 512), [
                [_directive_dompurify_html, _ctx.documentToHtmlString(this.contact)]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("section", null, [
              _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [
                [_directive_dompurify_html, _ctx.documentToHtmlString(this.links)]
              ]),
              (_ctx.version)
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                    _hoisted_17,
                    (_ctx.versionPrefix)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.versionPrefix), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_19, " " + _toDisplayString(_ctx.version) + " (" + _toDisplayString(_ctx.buildDate) + ")", 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("section", null, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_SimpleText, { "text-key": "footer.supportedby" })
              ]),
              _hoisted_22
            ])
          ])
        ]),
        (_ctx.languageSelectEnabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("ul", _hoisted_26, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "?lang=da",
                        lang: "da",
                        class: _normalizeClass({'selected': _ctx.currentLocale === 'da'}),
                        "aria-label": _ctx.currentLocale === 'da' ? 'Valgt sprog: Dansk' : 'Vælg sprog: Dansk',
                        onClick: _cache[0] || (_cache[0] = _withModifiers(async ()=> await _ctx.setLocale('da'), ["prevent"]))
                      }, [
                        (_ctx.currentLocale === 'da')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_31))
                          : _createCommentVNode("", true),
                        _createTextVNode(" Dansk ")
                      ], 10, _hoisted_27)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        href: "?lang=en-US",
                        lang: "en-US",
                        class: _normalizeClass({'selected': _ctx.currentLocale === 'en-US' && !_ctx.useTextKeys }),
                        "aria-label": _ctx.currentLocale === 'en-US' && !_ctx.useTextKeys ? 'Selected language: English' : 'Select language: English',
                        onClick: _cache[1] || (_cache[1] = _withModifiers(async ()=> await _ctx.setLocale('en-US'), ["prevent"]))
                      }, [
                        (_ctx.currentLocale === 'en-US' && !_ctx.useTextKeys )
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_33, _hoisted_36))
                          : _createCommentVNode("", true),
                        _createTextVNode(" English ")
                      ], 10, _hoisted_32)
                    ]),
                    (_ctx.isDevOrTest)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_37, [
                          _createElementVNode("a", {
                            href: "?lang=en-US",
                            lang: "en-US",
                            class: _normalizeClass(_ctx.currentLocale === 'en-US' && _ctx.useTextKeys && 'selected'),
                            "aria-label": _ctx.currentLocale === 'en-US' && _ctx.useTextKeys ? 'Selected language: Tekstnøgler' : 'Select language: Tekstnøgler',
                            onClick: _cache[2] || (_cache[2] = _withModifiers(()=>_ctx.setLocale('en-US', true), ["prevent"]))
                          }, [
                            (_ctx.currentLocale === 'en-US' && _ctx.useTextKeys )
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_39, _hoisted_42))
                              : _createCommentVNode("", true),
                            _createTextVNode(" Tekstnøgler ")
                          ], 10, _hoisted_38)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}